import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Tuinhuizen from "./pages/Tuinhuizen";
import Carport from "./pages/Carport";
import Poolhouse from "./pages/Poolhouse";
import Overkappingen from "./pages/Overkappingen";
import Divers from "./pages/Divers";

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tuinhuizen" element={<Tuinhuizen />} />
          <Route path="/carport" element={<Carport />} />
          <Route path="/poolhouse" element={<Poolhouse />} />
          <Route path="/overkappingen" element={<Overkappingen />} />
          <Route path="/divers" element={<Divers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
  );
}

export default App;
